<template>
  <div>
  <el-skeleton :loading="technicalSheetLoading" animated>
    <template slot="template">
      <div class="flex gaps auto">
        <el-skeleton-item
          variant="image"
          style="width: 240px; height: 240px;"
        />
        <span >
          <el-skeleton-item style="width:30%" /><br>
          <el-skeleton-item style="width:50%" />
        </span>
      </div>
      <el-divider />
      <div v-for="i in 10">
        <span v-if="i % 2 === 0">
          <el-skeleton-item style="width:20%" /> <el-skeleton-item class="ml-20" style="width:10%" />
        </span>
        <span v-else>
          <el-skeleton-item style="width:10%" /> <el-skeleton-item class="ml-20" style="width:20%" />
        </span>
      </div>
    </template>
     <template>
       <div v-if="data != null">
         <div class="flex gaps auto">
           <el-image
            :src="defaultImage"
            fit="contain"
            style="width: 200px; height: 200px;"
            class="imageSlot p-10 card-shadow--small">
             <div slot="error" class="imageSlot">
               <i class="el-icon-picture-outline"></i>
             </div>
           </el-image>
           <span>
             <span class="fs-14">
               {{$t('products.details.technicalSheet.reference')}}
               {{reference}}
             </span>
             <span class="fs-14">
               <br>
               {{$t('products.details.technicalSheet.webSite')}}
               <span v-if="webSite != null">
                 <el-link  :href="websiteUrl" target="_blank">
                   {{webSite}} <i class="mdi mdi-launch ml-10"></i>
                 </el-link>
               </span>
               <span v-else> -- </span>
             </span>
           </span>
           <span class="grow text-right">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-setting"
              :disabled="technicalSheetPdfLoading"
              @click="openTechnicalSheetDialog">
              {{ $t('products.details.technicalSheet.download') }}
            </el-button>
           </span>
          </div>
         <el-divider/>
         <div class="right-box box grow">
           <dl class="horizontal">
             <technicalSheetLine :data="prop" v-for="prop in properties" :key="prop.id"/>
           </dl>
         </div>
       </div>
       <div v-else class="m-20 flex gaps auto">
         <span class="fs-14" style="text-align:center">Aucune fiche technique disponible</span>
       </div>

     </template>
  </el-skeleton>

  <el-dialog
    :title="$t('products.details.technicalSheet.download')"
    :visible.sync="technicalSheetDialogVisible"
    width="520px"
    :close-on-click-modal="false"
  >
    <el-form label-position="top" size="small">
      <el-form-item label="Gabarit">
        <el-select
          v-model="selectedTechnicalSheetTemplate"
          style="width:100%"
          placeholder="Choisir un gabarit"
        >
          <el-option
            v-for="template in technicalSheetTemplateOptions"
            :key="template.value"
            :label="template.label"
            :value="template.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="Classe client">
        <el-select
          v-model="selectedCustomerClassId"
          clearable
          style="width:100%"
          placeholder="Par défaut"
        >
          <el-option
            v-for="customerClass in customerClasses"
            :key="customerClass.id"
            :label="customerClassLabel(customerClass)"
            :value="customerClass.id"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="technicalSheetDialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" :loading="technicalSheetPdfLoading" @click="downloadTechnicalSheetPdf">{{ $t('products.details.technicalSheet.download') }}</el-button>
    </span>
  </el-dialog>
  </div>

</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import technicalSheetLine from './technical-sheet-line';
import productItemApi from '@/services/API/productItem'
export default {
  name: 'technical-sheet-view',
	props: {
    id: {
      type: Number,
      default : null
    },
    puid: {
      type: String,
      default: null,
    },
    image : {
      type: String,
      default : null,
    }
	},
  data() {
    return {
      data : null,
      technicalSheetLoading: false,
      technicalSheetPdfLoading: false,
      technicalSheetDialogVisible: false,
      selectedTechnicalSheetTemplate: 'classic',
      selectedCustomerClassId: null,
      technicalSheetTemplateOptions: [
        { value: 'classic', label: 'Template Classique' },
        { value: 'split', label: 'Template Moderne' },
        { value: 'stacked', label: 'Template Épuré' },
      ],
    };
  },
  components: {
    technicalSheetLine,
  },
  watch : {
    id : function(val){
      if (val != null) {
        this.fetchProductItem(val);
      } else {
        this.data = null;
      }

    }
  },
	methods: {
    openTechnicalSheetDialog () {
      this.technicalSheetDialogVisible = true;
    },
    customerClassLabel (customerClass) {
      const code = _.trim(_.get(customerClass, 'code'));
      if (code !== '') return `${code}`;
      if (code !== '') return code;
      return `#${customerClass.id}`;
    },
    fetchProductItem (productItemId) {
      this.technicalSheetLoading = true;
      return productItemApi.getProductItem(productItemId)
        .then((productItem => {
          this.data = productItem;
          this.technicalSheetLoading = false;
        }))
        .catch((err) => {
          this.$message.error('Une erreur est survenue, veuillez réessayer plus tard');
          this.technicalSheetLoading = false;
          console.log(err);
        })
    },
    downloadTechnicalSheetPdf () {
      if (this.id == null) return Promise.resolve();

      this.technicalSheetPdfLoading = true;
      const fileReference = _.get(this.data, 'releaseYear') || this.id;
      return productItemApi.downloadTechnicalSheetPdf(
        this.id,
        `fiche-technique_${fileReference}.pdf`,
        this.puid,
        this.selectedTechnicalSheetTemplate,
        this.selectedCustomerClassId,
      )
        .catch((err) => {
          this.$message.error('Une erreur est survenue, veuillez réessayer plus tard');
          console.log(err);
        })
        .finally(() => {
          this.technicalSheetPdfLoading = false;
          this.technicalSheetDialogVisible = false;
        });
    },
    ...mapActions('controlData', ['fetchCustomerClasses']),
  },
	computed: {
    selectedTechnicalSheetTemplateLabel () {
      const selectedTemplate = _.find(this.technicalSheetTemplateOptions, { value: this.selectedTechnicalSheetTemplate });
      return _.get(selectedTemplate, 'label', 'Template Classique');
    },
    defaultTechnicalSheetTemplate () {
      const reportCustomization = this.getReportCustomization || {};
      const templateCode = _.lowerCase(_.get(reportCustomization, 'technicalSheetTemplate'));
      return _.includes(['classic', 'split', 'stacked'], templateCode) ? templateCode : 'classic';
    },
    defaultImage () {
      const technicalSheetImage = _.get(this.data, 'image.thumbnailLink');
      if (technicalSheetImage != null) return technicalSheetImage;
      return this.image;
    },
    properties () {
      return _.get(this.data, 'properties');
    },
    websiteUrl () {
      const webSite = this.webSite;
      if (!_.startsWith(webSite, 'http')) {
        return `http://${webSite}`;
      }
      return webSite;
    },
    reference () {
      return _.get(this.data, 'releaseYear');
    },
    webSite () {
      const webSite =  _.trim(_.get(this.data, 'webSite'));
      return webSite != '' ? webSite : null;
	    },
    ...mapState('controlData', ['customerClasses']),
    ...mapGetters(['getReportCustomization'])
	},
  mounted () {
    this.selectedTechnicalSheetTemplate = this.defaultTechnicalSheetTemplate;
    this.fetchCustomerClasses();
    if (this.id != null) {
      this.fetchProductItem(this.id);
    }
  },
}
</script>
<style lang="scss" scoped>

  .imageSlot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 30px;
  }

  dl {
    margin: 0px;
  }


</style>
